import { useCallback } from 'react';
import { generatePath, useHistory, useParams } from 'react-router';
import { Routes } from '@/core/router/routes.types';
import { useSelector } from 'react-redux';
import { useGetWebhooksQuery } from '@/services/innovorder/moduleExernalWebhooks/moduleExternalWebhooks.endpoints';
import { getUserToken } from '@/redux/user';
import { WebhookResponseData } from '@/services/innovorder/moduleExernalWebhooks/moduleExternalWebhooks.type';

export type IntegrationViewModel = {
    goToCreateWebhook: () => void;
    goToEditWebhook: (webhookId: number) => void;
    webhooks: WebhookResponseData[];
    isLoadingWebhooks: boolean;
};

type ParamTypes = {
    brandId: string;
};

export function useIntegrationsVM(): IntegrationViewModel {
    const history = useHistory();
    const { brandId } = useParams<ParamTypes>();
    const token = useSelector(getUserToken);

    const { data: webhooks = [], isLoading: isLoadingWebhooks } = useGetWebhooksQuery({
        token,
        brandId: Number(brandId),
        restaurantId: null, // Brand-level webhooks have no restaurant
    });

    const goToCreateWebhook = useCallback(
        () => history.push(generatePath(Routes.CreateBrandWebhook, { brandId })),
        [history, brandId],
    );

    const goToEditWebhook = useCallback(
        (webhookId: number) => history.push(generatePath(Routes.EditBrandWebhook, { brandId, webhookId })),
        [history, brandId],
    );

    return {
        goToCreateWebhook,
        goToEditWebhook,
        webhooks,
        isLoadingWebhooks,
    };
}
